import { ApiClient } from "lib/utils/client/apiClient";

export const getSellOfferedPropertiesListingByUserId = async (data: { customerId: string, page: number, limit: number }) => {
    return ApiClient('/customer-user/admin/offer-properties', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const getRentAgreementPropertiesListingByUserId = async (data: { customerId: string, page: number, limit: number }) => {
    return ApiClient('/customer-user/admin/rented-properties', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const getPaymentListingByUserId = async (data: { id: string, page: number, limit: number }) => {
    return ApiClient(`/customer-user/admin/payment-details`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const getTransactionDetailsByTransactionId = async (transactionId: string) => {
    return ApiClient(`/customer-user/admin/payment-details/transaction/${transactionId}`, {
        method: 'GET'
    });
}